<template>
    <div class="tag-list" style="font-size: 14px;">
      <template v-if="checkable || false">
        <a-checkable-tag
          style="margin-bottom: 4px; margin-top: 5px;"
          v-for="tag in tagList"
          :key="tag.id"
          :checked="tag.checked"
          @change="(checked) => handleChange(tag, checked)"
        >
          {{ tag.tag_name }}
        </a-checkable-tag>
      </template>
      <template v-else>
        <a-tag v-for="(tag, tagIndex) in tagList"
               :key="tag.id"
               style="margin-bottom: 4px; margin-top: 5px; animation-duration: 0s !important;"
               :closable="closable || false"
               @afterClose="() => handleClose(tagIndex)"
               :draggable="draggable || false"
               @dragstart="onDragStart($event, tagIndex)"
               :animated="false"
        >
          {{ tag.tag_name }}
        </a-tag>
      </template>
      <template v-if="newable || false">
        <a-input
          v-if="inputVisible"
          key="input-tag"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          style="margin-bottom: 4px; margin-top: 5px;"
          :value="inputValue"
          @change="handleInputChange($event)"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"></a-input>
        <a-tag key="new-tag" v-else @click="() => showInput()" style="margin-bottom: 4px; margin-top: 5px; background: #fff; borderStyle: dashed; animation-duration: 0s !important;">
          <a-icon type="plus"></a-icon> 新建
        </a-tag>
      </template>
    </div>
</template>

<script>
import Vue from 'vue'
import '../config/global'
const axios = require('axios')
export default {
  name: 'TagList',
  props: ['oriTagList', 'checkable', 'closable', 'newable', 'chatroomname', 'draggable', 'category_id'],
  data () {
    return {
      addTagUrlPostFix: 'add_tag',
      deleteTagUrlPostFix: 'delete_tag',
      unbindTagUrlPostFix: 'unbind_tag',
      chatroomName: this.chatroomname || '',
      tagList: this.assignOriTagList(this.oriTagList) || [],
      // isCheckable: this.checkable || false,
      // isClosable: this.closable || false,
      // isDraggable: this.draggable || false,
      inputVisible: false,
      inputValue: '',
      selectedTags: []
      // hasNewTag: this.newable || false
    }
  },
  watch: {
    oriTagList: function (newValue, oldValue) {
      this.tagList = this.assignOriTagList(this.oriTagList) || []
    },
    chatroomname: function (newValue, oldValue) {
      this.chatroomName = this.chatroomname || ''
    }
  },
  computed: {
    addTagUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.addTagUrlPostFix
    },
    deleteTagUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.deleteTagUrlPostFix
    },
    unbindTagUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.unbindTagUrlPostFix
    }
  },
  methods: {
    assignOriTagList (oriTagList) {
      let tagList = []
      oriTagList.forEach((tag) => {
        Vue.set(tag, 'checked', false)
        tag['checked'] = false
        tagList.push(tag)
      })
      // console.log(tagList)
      return tagList
    },
    handleClose (tagIndex) {
      const tagTmp = this.tagList[tagIndex]
      let url = this.deleteTagUrl
      if (this.chatroomName) {
        url = this.unbindTagUrl
      }
      axios.post(url, {
        tag_id: tagTmp.id,
        chatroomname: this.chatroomName,
        token: sessionStorage.token
      }).then((data) => {
        console.log('data.err_code:', data.data.err_code)
        if (data.data.err_code === 0) {
          // console.log(this.tagList)
          // this.emitAddTag(newTag)
          // this.tagList.splice(tagIndex, 1)
        } else if (data.data.err_code === 50002) {
          console.log('token 不对，跳转登录')
          this.$router.push('/')
        }
      })
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(function () {
        this.$refs.input.focus()
      })
    },
    handleInputChange (e) {
      this.inputValue = e.target.value
    },
    handleInputConfirm () {
      // console.log('handleInputConfirm')
      // console.log(this.inputValue)
      let inputValue = this.inputValue.trim()
      let tagList = this.tagList
      // console.log('tagListBefore:', tagList)
      let isDup = tagList.some((tag) => {
        return tag.tag_name === inputValue
      })
      // console.log('isDup', isDup)
      let newTag = null
      if (inputValue && !isDup) {
        axios.post(this.addTagUrl, {
          tag_name: this.inputValue,
          chatroomname: this.chatroomName,
          category_id: this.category_id,
          token: sessionStorage.token
        }).then((data) => {
          console.log('data.err_code:', data.data.err_code)
          if (data.data.err_code === 0) {
            console.log('tag:', data.data.content.tag)
            newTag = data.data.content.tag
            tagList = [...tagList, newTag]
            console.log('tagList:', tagList)
            this.tagList = tagList
            // console.log(this.tagList)
            this.inputVisible = false
            this.inputValue = ''
            this.emitAddTag(newTag)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
      } else {
        this.inputVisible = false
        this.inputValue = ''
      }
    },
    emitAddTag (newTag) {
      console.log('emitAddTag', newTag)
      this.$emit('on-add-tag', newTag)
    },
    handleChange (tag, checked) {
      // tag.checked = checked
      // const { selectedTags } = this
      // if (checked) {
      //   let isDup = selectedTags.some((selectedTag) => {
      //     return tag.value === selectedTag.value
      //   })
      //   if (!isDup) {
      //     this.selectedTags = [...selectedTags, tag]
      //   }
      // } else {
      //   this.selectedTags = selectedTags.filter(t => t.name !== tag.name)
      // }
      // console.log('You are interested in: ', this.selectedTags)
      this.$emit('on-tag-change', tag, checked)
    },
    onDragStart (e, tagIndex) {
      console.log('onDragStart', e)
      const tag = this.tagList[tagIndex]
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('tag_name', tag.tag_name)
      e.dataTransfer.setData('tag_id', tag.id)
      this.$emit('on-delete-tag', tagIndex)
    }
  }
}
</script>
